<button class="chat-button" (click)="speakSupport()" title="{{'Contact support' | translate}}">
  <span class="fa-stack">
    <i class="fa fa-envelope fa-2x"></i>
    <i *ngIf="checkReadStatus()" class="fa fa-circle fa-stack-1x notification"></i>
 </span>
</button>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" translate>Conversation with <span class="badge badge-support" translate>Support</span></h4>
    <button type="button" class="btn btn-outline-primary refresh-btn" title="{{'Refresh supports' | translate}}" (click)="loadSupports()">
      <span class="la la-circle-notch{{loading? ' la-spin' : ''}}"></span> 
      <span *ngIf="loading" class="d-none d-sm-inline d-md-inline d-lg-inline d-xl-inline"> {{'Refreshing...' | translate}}</span>
      <span *ngIf="!loading" class="d-none d-sm-inline d-md-inline d-lg-inline d-xl-inline"> {{'Refresh messages' | translate}}</span>
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <app-chat-support [messages]="supports" [me]="me" [friend]="friend" [src_id]="src_id" [dest_id]="dest_id"></app-chat-support>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.close('Close click')" translate>Close</button>
  </div>
</ng-template>